/**
 * @author Jorge Casas
 * @creationDate 12/07/2024
 */

/**
 * This function formats a number into a string with a currency format.
 * It uses the toLocaleString method to format the number.
 * It also uses the es-MX locale to format the number with the currency format of Mexico.
 *
 * @param {number} amount - The number to be formatted.
 * @returns {string} - The formatted number.
 * @throws {Error} - If the amount is not a number.
 */
export const formatAmount = (amount) => {
  try {
    if (typeof amount === 'number') {
      return amount.toLocaleString('es-MX', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } else {
      console.log('Is the amount a number? No, it is not a number');
      return '';
    }
  } catch (error) {
    console.log('🚀 ~ file: format-amount.js:27 ~ formatAmount ~ error:', error);
    return '';
  }
};



// WEBPACK FOOTER //
// src/utils/additional-functions/format-amount.js